import React from 'react'

const EmployerDetails = () => {
  return (
    <div>EmployerDetails</div>
  )
}

export default EmployerDetails